<template>
  <div class="dropDown">
    <button @click="openClose" class="dropButton">{{resultsType}}</button>
    <Transition name="scale">
      <table v-if="open" class="resultsTable">
        <thead v-if="studentResults.length > 0">
          <tr>
            <th class="testColumn">{{ t("testName") }}</th>
            <th class="scoreColumn">{{ t("score") }}</th>
            <th class="dateColumn">{{ t("date") }}</th>
          </tr>
        </thead>
        <tbody v-if="studentResults.length > 0">
          <tr v-for="(studentResult, index) in studentResults" :key="index">
            <td class="testColumn">{{studentResult.testName}}</td>
            <td class="scoreColumn">{{studentResult.score}}</td>
            <td class="dateColumn">{{new Date(studentResult.date).toLocaleDateString("en-GB")}}</td>
          </tr>
        </tbody>
        <thead v-else>
          <tr>
            <th>{{ t("noResults") }}</th>
          </tr>
        </thead>
      </table>
    </Transition>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },
  name: "DropDownComponent",
  props: {
    studentResults: {
      type: [Array],
      required: true
    },
    resultsType: {
      type: [String],
      reqired: true
    }
  },
  data() {
    return {
      open: false
    };
  },

  methods: {
    openClose() {
      this.open = !this.open;
    }
  }
};
</script>
<i18n>
{
  "en-GB": {
    "testName": "Test name",
    "score": "Score",
    "date": "Date",
    "noResults": "There are no results to show yet."
  },
  "nl-NL": {
    "testName": "Test naam",
    "score": "Resultaat",
    "date": "Datum",
    "noResults": "There are no results to show yet."
  }
}
</i18n>

<style scoped>
.dropDown {
  margin-bottom: 50px;
  width: 80%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.dropButton {
  display: block;
  padding: 25px 25px;
  margin: 0px;
  border: 0px;
  cursor: pointer;
  background-color: rgb(165, 0, 41);
  font-family: "Raleway", sans-serif;
  font-size: 20px;
  letter-spacing: 1.5px;
  width: 100%;
  font-weight: 600;
  text-transform: uppercase;
  color: white;
}

.resultsTable {
  border-spacing: 0px;
  border-collapse: collapse;
  letter-spacing: 1px;
}
.testColumn {
  width: 70%;
}

th {
  font-size: 18px;
  padding: 10px;
  background-color: rgb(216, 216, 216);
}
td {
  background-color: rgb(235, 235, 235);
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 12px;
  padding-right: 12px;
  font-weight: 250;
}

th,
td {
  width: 15%;
  border-top: 0.5px solid rgb(54, 54, 54);
  border-bottom: 0.5px solid rgb(54, 54, 54);
  margin: 0px;
  color: rgb(0, 0, 0);
}

.noResults {
  font-size: 18px;
  padding: 10px;
  background-color: rgb(216, 216, 216);
}

.scale-enter-active,
.scale-leave-active {
  transform-origin: top;
  transition: transform 0.5s ease-in-out;
}

.scale-enter-to,
.scale-leave-from {
  transform: scaleY(1);
}

.scale-enter-from,
.scale-leave-to {
  transform: scaleY(0);
}

@media screen and (max-width: 1200px) {
  .dropDown {
    margin-bottom: 30px;
  }

  .dropButton {
    padding: 18px 18px;
    margin: 0px;
    font-size: 17px;
    letter-spacing: 1px;
  }

  .resultsTable {
    letter-spacing: 0.6px;
  }

  th {
    font-size: 15px;
    padding: 10px;
  }
  td {
    font-size: 15px;
  }
}

@media screen and (max-width: 950px) {
  .dropDown {
    margin-bottom: 25px;
  }

  .dropButton {
    padding: 16px 16px;
    margin: 0px;
    font-size: 16px;
  }

  th {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  td {
    font-size: 14px;
  }
}

@media screen and (max-width: 500px) {
  .dropDown {
    width: 90%;
  }
  .dropButton {
    padding: 13px 13px;

    font-size: 13.5px;
  }

  th {
    font-size: 13px;
  }
  td {
    font-size: 13px;
  }
}
@media screen and (max-width: 370px) {
  th {
    font-size: 12px;
  }
  td {
    font-size: 12px;
    padding: 7px;
  }
}

@media screen and (max-width: 330px) {
  .testColumn {
    width: 40%;
    padding: 5px;
  }
  .scoreColumn {
    width: 30%;
    padding: 5px;
    padding-left: 0px;
  }
  .dateColumn {
    width: 30%;
    padding: 5px;
    padding-left: 0px;
    width: 50px;
  }
  th {
    font-size: 11px;
  }
  td {
    font-size: 10.5px;
  }
}
@media screen and (max-width: 260px) {
  .scoreColumn {
    padding: 5px;
    padding-left: 0px;
  }
  .dateColumn {
    padding: 5px;
    padding-left: 0px;
  }
  th {
    font-size: 11px;
  }
  td {
    font-size: 10.5px;
  }
}
</style>

